import { render } from "./TsListPage.vue?vue&type=template&id=0d285ee5&scoped=true"
import script from "./TsListPage.vue?vue&type=script&lang=js"
export * from "./TsListPage.vue?vue&type=script&lang=js"

import "./TsListPage.vue?vue&type=style&index=0&id=0d285ee5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d285ee5"]])

export default __exports__